import utcToZonedTime from 'date-fns-tz/utcToZonedTime'
import copy from 'copy-to-clipboard'

import {
  formButtons,
  replaceQuillText,
} from '@/functions/post'

import {
  getDefaultButton,
} from '@/functions/utils'

import {useNewpostStore} from '@/store/pinia/newpost'
import {showSuccessSnackbar, showErrorSnackbar} from '@/functions/snackbar'

const newpostStore = useNewpostStore()

export const timerMixin = {
  methods: {
    savePublishTime(date) {
      newpostStore.state.isScheduled = true
      newpostStore.state.scheduledDate = date
    },
    clearPublishTime() {
      newpostStore.state.isScheduled = false
      newpostStore.state.scheduledDate = false
    },
  },
}

export const textValidationMixin = {
  computed: {
    textTooShort() {
      return !newpostStore.state.media && this.text.length === 0
    },
    textTooLong() {
      return (!newpostStore.state.media || newpostStore.state.mediaPosition === 'bottom')
        && this.text.length > 4096
    },
    captionTooLong() {
      return newpostStore.state.media && newpostStore.state.mediaPosition === 'top' && this.text.length > 1024
    },
  },
}

export const formPostMixin = {
  computed: {
    post() {
      const is_schedule = this.getIsSchedule()
      return {
        type: this.postType,

        text: this.text,
        ...this.mediaChosen && {
          photo_url: newpostStore.state.media.url,
        },

        notifications: newpostStore.state.notifications,

        buttons: formButtons(newpostStore.state.buttons),
        answer_stats: newpostStore.state.answerStats,
        limit_answer: newpostStore.state.limitAnswer,

        channel_id: newpostStore.state.selectedChannelId,

        is_schedule,
        schedule_time: is_schedule && newpostStore.state.scheduledDate,
      }
    },
  },
}

export const editorMixin = {
  computed: {
    quill() {
      if (!this || !this.$refs || !this.$refs.quill) {
        return
      }
      return this.$refs.quill.quill
    },
    editorPlaceholder() {
      return this.$t(`post.editorPlaceholder.${this.postType}`)
    },
  },
}

export const commonMixin = {
  data: () => ({
    timerSet: false,
  }),
  methods: {
    clearKeyboard() {
      newpostStore.state.buttons = [[getDefaultButton()]]
    },

    getIsSchedule() {
      return newpostStore.state.isScheduled && this.scheduleTime && this.scheduleTime.getTime() > Date.now()
    },
    updateTimerSet() {
      this.timerSet = this.getIsSchedule()
    },

    prepareDateForFormat(date) {
      return utcToZonedTime(date, this.selectedChannelTimezone, true)
    },

    async exportPostCopy() {
      await copy(JSON.stringify(this.post))
      showSuccessSnackbar(this.$t(`post.export.copied`))
    },
    importPost(raw) {
      Object.assign(
        newpostStore.state,
        {
          selectedChannelId: this.channels.find((v) => v.cid === raw.channel_id) ? raw.channel_id : this.channels[0].cid,

          answerStats: raw.answer_stats,
          limitAnswer: raw.limit_answer,
          notifications: raw.notifications,

          mediaPreviewEnabled: !!raw.photo_url,
          media: raw.photo_url && {
            url: raw.photo_url,
            web_url: raw.photo_url,
          },
          mediaPosition: raw.type === 'text' ? 'bottom' : 'top',

          rawText: raw.text && raw.text.replace(/\n/g, '<br>') || '',

          buttons: raw.buttons,

          isScheduled: raw.is_schedule,
          ...raw.is_schedule && {
            scheduledDate: new Date(raw.schedule_time),
          },
        },
      )
    },

    importPostShowDialog() {
      const text = prompt(this.$t('post.import.inputData').toString())
      let json
      try {
        json = JSON.parse(text)
      } catch (e) {
        showErrorSnackbar(this.$t('post.import.wrongData').toString())
      }
      this.importPost(json)
      showSuccessSnackbar(this.$t('post.import.successful'))
    },
  },
  computed: {
    channels() {
      return this.$store.state.auth.userChannels
    },

    store() {
      return newpostStore
    },
    state() {
      return newpostStore.state
    },

    text() {
      return replaceQuillText(newpostStore.state.rawText)
    },

    scheduleTime() {
      return newpostStore?.state?.scheduledDate || new Date()
    },

    selectedChannel() {
      return newpostStore.selectedChannel || {}
    },

    selectedChannelTimezone() {
      return this.selectedChannel?.settings?.timezone_id || 'Etc/GMT'
    },

    postType() {
      return (this.mediaChosen && newpostStore.state.mediaPosition === 'top')
        ? 'photo'
        : 'text'
    },

    answerCharLimit() {
      if (newpostStore.state.answerStats && newpostStore.selectedChannel) {
        const selectedChannel = newpostStore.selectedChannel.value
        const lang = selectedChannel && selectedChannel.settings && selectedChannel.settings.lang || 'ru'
        const additionalTextLength = (lang) => {
          switch (lang) {
            case 'ru':
              return 'Ответили так же: xxxxx чел. (xx.xx%)'.length + 2
            case 'ua':
              return 'Відповіли так само: xxxxx чол. (xx.xx%)'.length + 2
            case 'en':
              return 'xxxxx people answered the same (xx.xx%)'.length + 2
            case 'uz':
              return 'Sizdek javob berishdi: xxxxx kishi (xx.xx%)'.length + 2
            case 'uz_cyrillic':
              return 'Сиздек жавоб беришди: xxxxx киши (xx.xx%)'.length + 2
            default:
              return 170
          }
        }
        return 200 - additionalTextLength(lang)
      }
      return 200
    },
  },
  watch: {
    scheduleTime() {
      this.updateTimerSet()
    },
  },
  mounted() {
    this.updateTimerSetInterval = setInterval(() => this.updateTimerSet(), 10000)
  },
  beforeDestroy() {
    clearInterval(this.updateTimerSetInterval)
  },
}
